import axios from 'axios'
import {BASE_URL, API_VERSION, ACTIVITIES} from '../endpoints'

export const GET_ALL_ACTIVITIES = 'GET_ALL_ACTIVITIES'
export const GET_ACTIVITY = 'GET_ACTIVITY'
export const ADD_ACTIVITY = 'ADD_ACTIVITY'
export const EDIT_ACTIVITY = 'EDIT_ACTIVITY'
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY'
export const CLEAR_ACTIVITY = 'CLEAR_ACTIVITY'

export const GET_ACTIVITIES = 'GET_ACTIVITIES'

export const getAllItems = (page, size, search) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${ACTIVITIES}/admin?page=${page}&size=${size}&search=${search}&admin=true`, options)
        .then((response) => {

            dispatch({
                type: GET_ALL_ACTIVITIES,
                payload: {
                    activities: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const getItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${ACTIVITIES}/${id}`, options)
        .then((response) => {
            dispatch({
                type: GET_ACTIVITY,
                payload: {
                    activity: response.data.data,
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const addItem = (payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        }
    }
    return axios.post(BASE_URL + ACTIVITIES, payload, apiHeader)
        .then(response => {
            console.log(response.data)
            // dispatch({ type: ADD_ACTIVITY, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + ACTIVITIES + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_ACTIVITY, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + ACTIVITIES + '/' + id, payload, apiHeader)
        .then(response => {
            dispatch({ type: GET_ACTIVITY, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const clearItem = () => (dispatch) => {
    dispatch({ type: CLEAR_ACTIVITY });
}


export const getActivities = (query) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    const queryString = new URLSearchParams(query).toString();

    return axios.get(`${BASE_URL}${ACTIVITIES}?${queryString}`, options)
        .then((response) => {

            dispatch({
                type: GET_ACTIVITIES,
                payload: {
                    activities: response.data.data.activities,
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};


